import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const base =
  "group inline-flex items-center justify-center gap-3 rounded-full px-7 py-3.5 text-sm font-medium tracking-wide transition-colors duration-300";
const variants = {
  primary: "bg-raiz-800 text-paper hover:bg-raiz-700",
  light: "bg-paper text-raiz-900 hover:bg-raiz-100",
  outline: "border border-raiz-800/30 text-raiz-800 hover:border-raiz-800 hover:bg-raiz-800 hover:text-paper",
  outlineLight: "border border-paper/40 text-paper hover:bg-paper hover:text-raiz-900",
};

export const ArrowButton = ({ href, to, children, variant = "primary", testId, className = "", ...rest }) => {
  const cls = `${base} ${variants[variant]} ${className}`;
  const arrow = (
    <ArrowRight
      aria-hidden="true"
      className="h-4 w-4 shrink-0 transition-transform duration-300 group-hover:translate-x-1.5"
    />
  );
  if (to) {
    return (
      <Link to={to} data-testid={testId} className={cls} {...rest}>
        {children}
        {arrow}
      </Link>
    );
  }
  return (
    <a href={href} data-testid={testId} className={cls} {...rest}>
      {children}
      {arrow}
    </a>
  );
};
